import { call, put, takeLeading, takeLatest, select } from "redux-saga/effects";
import { getAuthToken } from "../Benutzer";
import {
	FETCH_HEDATA_LOGS_LIST_REQUESTED,
	FETCH_HEDATA_LOGS_LIST_SUCCEEDED,
	FETCH_HEDATA_LOGS_LIST_FAILED,
	FETCH_HEDATA_LOG_FILE_REQUEST,
	FETCH_HEDATA_LOG_FILE_SUCCEEDED,
	FETCH_HEDATA_LOG_FILE_FAILED,
	FETCH_MULTIPLE_HEDATA_LOG_FILES_REQUEST,
	FETCH_MULTIPLE_HEDATA_LOG_FILES_SUCCEEDED,
	FETCH_MULTIPLE_HEDATA_LOG_FILES_FAILED,
	PURPOSE_LOG_VALUES,
	PURPOSE_DAILY_VALUES,
	PURPOSE_ENERGY_BALANCE_CSV,
	PURPOSE_ENERGY_BALANCE_PDF
} from "../HeDataLogs"
import {
	CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES,
	setDailyTimespanAction,
	setXRangeAction,
	setDailyValuesAction,
	CHARTS_SET_XRANGE,
	setChartsLogValuesAction,
	setChartsStateChangesAction
} from "../Diagramme"
import {
	generateHeDataLogItemFromDate,
	isHeDataLogItemInRange,
	createLogValues,
	createStateChanges,
	calcLastLeerlauf,
	calcMotorstarts,
	calcEnergiverbrauch,
	calcGeliefertesVolumen,
	calcSpezifischeLeistungsaufnahme,
	getDataPoints,
	createEnergyBalanceRawData
} from "../util/HeDataLogFiles"
import { fetchMultipleHeDataLogFilesRequestAction } from "../HeDataLogs"
import { makeAndShowEnergyBalance } from "../../energiebilanzierung/EnergieBilanz"

const pathHeDataLogsList = "/hedata/logs/list";
const pathHeDataLogsBase = "/hedata/logs";

////////////////////
// helpder-functions
////////////////////

const fitDataOfListOfFiles = (listOfFiles) =>
{
	// only use MCHE files
	const mcheFiles = listOfFiles.filter((entry) => { return entry.name.includes("MCHE-"); });

	// edit data representation
	let arrayOfAvailableDays = [];
	mcheFiles.forEach((item, index) => {
		let availableDay = {
			year: parseInt(item.name.slice(5,9)),
			month: parseInt(item.name.slice(10,12)),
			day: parseInt(item.name.slice(13,15)),
			filePath: item.path,
			file: null
		};
		arrayOfAvailableDays.push(availableDay);
	})

	// sort data by date, oldest first
	arrayOfAvailableDays.sort((a, b) => {
		// sort(compareFn?: (a: any, b: any) => number): any[]
		// Function used to determine the order of the elements.
		// It is expected to return a negative value if first argument is less than second argument,
		// zero if they're equal and a positive value otherwise.
		// If omitted, the elements are sorted in ascending, ASCII character order.
		// [11,2,22,1].sort((a, b) => a - b)

		// check year
		let diff = a.year - b.year;
		if(diff !== 0) {
			return diff;
		}
		// check month
		diff = a.month - b.month;
		if(diff !== 0) {
			return diff;
		}
		// check day
		diff = a.day - b.day;
		return diff;
	});

	return arrayOfAvailableDays;
}

const fetchLogFile = (fileIndex, he_data_log_files) => {
	const completeFilePath = pathHeDataLogsBase + "/" + he_data_log_files.sortedListOfAvailableDays[fileIndex].filePath;
	return call(
		fetch,
		completeFilePath,
		{
			method: "GET",
			headers: {
				"Accept": "text/plain",
				"Authorization": "Bearer " + getAuthToken()
			}
		}
	);
}

///////////////
// worker-sagas
///////////////

function* fetchHeDataLogFile(action)
{
	try {
		const he_data_log_files = yield select((state) => { return state.he_data_log_files; })
		const fileObj = he_data_log_files.sortedListOfAvailableDays[action.index].file
		if(
			(fileObj == null) || // check for null
			(Object.keys(fileObj).length === 0 && fileObj.constructor === Object) // check for empty object
		) {
			const response = yield fetchLogFile(action.index, he_data_log_files)
			const ok = yield response.ok;
			if(ok) {
				let payload = yield response.text();
				yield put({type: FETCH_HEDATA_LOG_FILE_SUCCEEDED, index: action.index, fileContent: payload});
			}
			else {
				yield put({type: FETCH_HEDATA_LOG_FILE_FAILED, message: "response not ok"});
			}
		}
		else { // data already downloaded
			yield put({type: FETCH_HEDATA_LOG_FILE_SUCCEEDED, index: action.index, fileContent: null})
		}
	}
	catch (e) {
		yield put({type: FETCH_HEDATA_LOG_FILE_FAILED, message: e.message});
	}
}

function* fetchMultipleHeDataLogFiles(action)
{
	try {
		const he_data_log_files = yield select((state) => { return state.he_data_log_files; })
		// go through list of indexes and fetch the files
		let isError = false;
		// auf maximal 7 Tage begrenzen: es könnte sonst zu Performance-Problemen kommen, wenn ein sehr langer Zeitraum gewählt wird.
		// außerdem: beim Auswählen des Zeitraums kann es passieren, dass kurzzeitig ein sehr großer Zeitraum ausgewählt ist.
		let nFiles = action.requestedFiles.length
		if(nFiles > 7) {
			nFiles = 7
		}
		// Dateien holen
		for(let i = 0; i < nFiles; ++i) { // forEach() kann man leider nicht benutzen, da yield in einem callback nicht funktioniert
			const item = action.requestedFiles[i]
			const fileObj = he_data_log_files.sortedListOfAvailableDays[item].file
			if(
				(fileObj == null) || // check for null
				(Object.keys(fileObj).length === 0 && fileObj.constructor === Object) // check for empty object
			) {
				const response = yield fetchLogFile(item, he_data_log_files)
				const ok = yield response.ok
				if(ok) {
					let payload = yield response.text()
					yield put({type: FETCH_HEDATA_LOG_FILE_SUCCEEDED, index: item, fileContent: payload})
				}
				else {
					yield put({type: FETCH_HEDATA_LOG_FILE_FAILED, message: "response not ok"})
					isError = true
					break
				}
			}
			else { // data already loaded
				yield put({type: FETCH_HEDATA_LOG_FILE_SUCCEEDED, index: action.index, fileContent: null})
			}
		}
		// check error state
		if(isError === true) {
			yield put({type: FETCH_MULTIPLE_HEDATA_LOG_FILES_FAILED, message: "response not ok"})
		}
		else {
			yield put({type: FETCH_MULTIPLE_HEDATA_LOG_FILES_SUCCEEDED, purpose: action.purpose, requiredData: action.requiredData})
		}
	}
	catch (e) {
		yield put({type: FETCH_HEDATA_LOG_FILE_FAILED, message: e.message})
		yield put({type: FETCH_MULTIPLE_HEDATA_LOG_FILES_FAILED, message: e.message})
	}
}

function* fetchHeDataLogsList()
{
    try {
		const response = yield call(
			fetch,
			pathHeDataLogsList,
			{
				method: "GET",
				headers: {
					"Accept": "application/json",
					"Authorization": "Bearer " + getAuthToken()
				}
			}
		);
		const ok = yield response.ok;
		if(ok) {
			let payload = yield response.json();
			const arrayOfAvailableDays = yield fitDataOfListOfFiles(payload);
			yield put({type: FETCH_HEDATA_LOGS_LIST_SUCCEEDED, sortedListOfAvailableDays: arrayOfAvailableDays});
		}
		else {
			yield put({type: FETCH_HEDATA_LOGS_LIST_FAILED, message: "response not ok"});
		}
    } catch (e) {
    	yield put({type: FETCH_HEDATA_LOGS_LIST_FAILED, message: e.message});
    }
}

function* setValidTimeRange()
{
	const xrange = yield select(state => (state.he_data_log_files.xrange))
	const chartsDataSourceIndex = yield select((state) => { return state.charts.data_source_index; });
	if(chartsDataSourceIndex === CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES) {
		yield put(setDailyTimespanAction(xrange[1], xrange[1]))
		yield put(setXRangeAction([xrange[1], xrange[1]]))
	}
}

function* fetchMultipleHeDataLogFilesSucceeded(action)
{
	// get data from redux-state
	const sortedListOfAvailableDays = yield select((state) => { return state.he_data_log_files.sortedListOfAvailableDays })
	const xrange = yield select(state => (state.charts.x_range))

	if(action.purpose === PURPOSE_LOG_VALUES) {
		// fill charts.log_values and charts.state_changes
		const dataPoints = yield getDataPoints(xrange, sortedListOfAvailableDays)

		const logValues = yield createLogValues(dataPoints)
		const stateChanges = yield createStateChanges(dataPoints)

		yield put(setChartsLogValuesAction(logValues))
		yield put(setChartsStateChangesAction(stateChanges))
	}
	else if(action.purpose === PURPOSE_DAILY_VALUES) {
		// fill charts.daily_values
		const requestedTimespan = yield select((state) => { return state.charts.daily_values.timespan })
		const itemMin = yield generateHeDataLogItemFromDate(new Date(requestedTimespan.from_ms))
		const itemMax = yield generateHeDataLogItemFromDate(new Date(requestedTimespan.until_ms))
		const requestedDaysDailyValues = sortedListOfAvailableDays.filter((item) => (isHeDataLogItemInRange(item, itemMin, itemMax)))

		const lastLeerlaufData = yield calcLastLeerlauf(requestedDaysDailyValues)
		const motorstartsData = yield calcMotorstarts(requestedDaysDailyValues)
		const energieverbrauchData = yield calcEnergiverbrauch(requestedDaysDailyValues)
		const geliefertesVolumenData = yield calcGeliefertesVolumen(requestedDaysDailyValues)
		const spezifischeLeistungsaufnahmeData = yield calcSpezifischeLeistungsaufnahme(energieverbrauchData, geliefertesVolumenData)

		yield put(setDailyValuesAction("last_leerlauf", lastLeerlaufData, requestedTimespan.from_ms, requestedTimespan.until_ms, Date.now()))
		yield put(setDailyValuesAction("motorstarts", motorstartsData, requestedTimespan.from_ms, requestedTimespan.until_ms, Date.now()))
		yield put(setDailyValuesAction("spezifische_leistungsaufnahme", spezifischeLeistungsaufnahmeData, requestedTimespan.from_ms, requestedTimespan.until_ms, Date.now()))
		yield put(setDailyValuesAction("energieverbrauch", energieverbrauchData, requestedTimespan.from_ms, requestedTimespan.until_ms, Date.now()))
	}
	else if(
		(action.purpose === PURPOSE_ENERGY_BALANCE_CSV) ||
		(action.purpose === PURPOSE_ENERGY_BALANCE_PDF)
	) {
		const itemMin = yield generateHeDataLogItemFromDate(new Date(action.requiredData.range.from_ms))
		const itemMax = yield generateHeDataLogItemFromDate(new Date(action.requiredData.range.until_ms))
		const requestedDaysEnergyBalance = sortedListOfAvailableDays.filter((item) => (isHeDataLogItemInRange(item, itemMin, itemMax)))
		const data = yield createEnergyBalanceRawData(action.requiredData, requestedDaysEnergyBalance)
		yield makeAndShowEnergyBalance(
			data,
			action.requiredData.compressors,
			action.requiredData.settings,
			action.requiredData.units,
			action.requiredData.intl,
			action.requiredData.type,
			action.requiredData.version
		)
	}
	else {
		; // do nothing
	}
}

function* fetchMultipleHeDataLogFilesFailed()
{
	console.log("ERROR: fetchMultipleHeDataLogFilesFailed(): setting all data to nothing")

	// charts.log_values
	yield put(setChartsLogValuesAction([]))

	// charts.state_changes
	yield put(setChartsStateChangesAction({
		num_compressors: 1,
		changes: []
	}))

	// charts.daily values
	const timespan = yield select((state) => { return state.charts.daily_values.timespan; });
	let from_ms = timespan.from_ms
	let until_ms = timespan.until_ms
	yield put(setDailyValuesAction("last_leerlauf", [], from_ms, until_ms, Date.now()))
	yield put(setDailyValuesAction("motorstarts", [], from_ms, until_ms, Date.now()))
	yield put(setDailyValuesAction("spezifische_leistungsaufnahme", [], from_ms, until_ms, Date.now()))
	yield put(setDailyValuesAction("energieverbrauch", [], from_ms, until_ms, Date.now()))
}

function* determineAndRequestHeDataLogFiles()
{
	const dataSourceIndex = yield select(state => (state.charts.data_source_index))
	if(dataSourceIndex === CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES) {
		const sortedListOfAvailableDays = yield select(state => (state.he_data_log_files.sortedListOfAvailableDays))
		const requested_xrange = yield select(state => (state.charts.x_range))
		const itemMin = yield generateHeDataLogItemFromDate(new Date(requested_xrange[0]))
		const itemMax = yield generateHeDataLogItemFromDate(new Date(requested_xrange[1]))
		let listOfFiles = []
		sortedListOfAvailableDays.forEach((item, index) => {
			if(isHeDataLogItemInRange(item, itemMin, itemMax)) {
				listOfFiles.push(index)
			}
		})
		yield put(fetchMultipleHeDataLogFilesRequestAction(listOfFiles, PURPOSE_LOG_VALUES))
	}
}

////////////////
// watcher-sagas
////////////////

export function* watchFetchHeDataLogsListRequest() {
	yield takeLeading(FETCH_HEDATA_LOGS_LIST_REQUESTED, fetchHeDataLogsList);
}

export function* watchFetchHeDataLogFileRequest() {
	yield takeLeading(FETCH_HEDATA_LOG_FILE_REQUEST, fetchHeDataLogFile);
}

export function* watchFetchHeDataLogsListSucceeded() {
	yield takeLeading(FETCH_HEDATA_LOGS_LIST_SUCCEEDED, setValidTimeRange);
}

export function* watchFetchMultipleHeDataLogFilesRequest() {
	yield takeLatest(FETCH_MULTIPLE_HEDATA_LOG_FILES_REQUEST, fetchMultipleHeDataLogFiles);
}

export function* watchFetchMultipleHeDataLogFilesSucceeded() {
	yield takeLatest(FETCH_MULTIPLE_HEDATA_LOG_FILES_SUCCEEDED, fetchMultipleHeDataLogFilesSucceeded)
}

export function* watchFetchMultipleHeDataLogFilesFailed() {
	yield takeLatest(FETCH_MULTIPLE_HEDATA_LOG_FILES_FAILED, fetchMultipleHeDataLogFilesFailed)
}

export function* watchSetChartsXRange() {
	yield takeLatest(CHARTS_SET_XRANGE, determineAndRequestHeDataLogFiles)
}